import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";

export const AgroScreen: React.FC = () => {
	return (
		<>
			<Row
				flexible
				mainAxisAlignment="center"
				crossAxisAlignment="center"
				className="relative py-14 max-md:px-5 md:py-36 bg-cover bg-[url('https://imgs.mongabay.com/wp-content/uploads/sites/25/2020/07/21125550/agroquimicos-gran-chaco-argentino.jpg')] bg-center"
				responsiveCol
			>
				<div className="absolute bg-black/40 top-0 left-0 w-full h-full" />
				<Column
					className="w-full z-[1]"
					data-sal="zoom-out"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="extraBig"
						className="font-title max-md:text-4xl text-center !leading-none text-white"
					>
						Contaminación <br /> Agroquímica
					</TextComponent>
				</Column>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:py-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<img
					className="w-full md:w-2/5 h-60 object-cover rounded-lg max-md:order-last"
					src="https://scontent.ftcq2-1.fna.fbcdn.net/v/t39.30808-6/484844853_993769972906606_652702020593175922_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeGUzBK8nLfw9zl6rbyTDWaZkiKBPA7B2qOSIoE8DsHao6eNJshWheE9LJuARZVRtfGHwwmeBrCEIQLunOWRqobe&_nc_ohc=bOJxpgv7OPwQ7kNvwE0M2_g&_nc_oc=Adn8h_n92dKD886ODBi_a1Ktqa0i1d-WAoK49BnG6eyxdZ7irQ1I4pnnLvCWxax-ops&_nc_zt=23&_nc_ht=scontent.ftcq2-1.fna&_nc_gid=NELZkja1FoJBv3tAEpfPCA&oh=00_AfJuGE0ypOVTHOVs_Lf9o-FyflMUtZGtZF0najq_DdE-1Q&oe=682D925A"
					alt="desecho de residuos organicos"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<Column
					className="md:w-3/5 rounded-lg md:gap-4 gap-2"
					data-sal="slide-left"
					data-sal-duration="1000"
					mainAxisAlignment="center"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						Desecho de residuos orgánicos (eutrofización)
					</TextComponent>
					<TextComponent variant="h5">
						Los <span className="font-semibold text-green-600">fertilizantes</span> que se utilizan en la agricultura de la{" "}
						<span className="text-cyan-600 font-bold">Yarada Los Palos</span>, están afectando de manera directa a la <span className="text-green-600 font-bold">población marina</span>.
						Los nutrientes que necesitan sus plantaciones, como el <span className="font-bold text-yellow-600">nitrógeno</span> y <span className="font-bold text-yellow-600">fósforo</span>
						, son acarreados hasta llegar al mar, provocando un <span className="font-semibold text-red-600">florecimiento excesivo de algas y otras plantas verdes</span> que cubren la
						superficie del agua, consumen todo el <span className="text-blue-600 font-bold">oxígeno</span> del agua y a la vez no permiten que la{" "}
						<span className="font-semibold">luz solar</span> ingrese para los demás seres vivos. Todo esto se llama <span className="text-red-600 font-bold">Eutrofización</span>.
					</TextComponent>
				</Column>
			</Row>
			<Column className="grid grid-cols-1 md:grid-cols-2 sm:w-[40rem] md:w-[50rem] xl:w-[60rem] gap-5 self-center py-10 max-md:px-5">
				<img
					className="rounded-lg"
					src="https://scontent.ftcq2-1.fna.fbcdn.net/v/t1.6435-9/124124318_126192982596519_2687383293753905685_n.png?_nc_cat=110&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeFTzpYyB_0DT7pYi7w2trNtB7B_kHmd2wMHsH-QeZ3bA6Cx-OzDKvRl2x1MjKwspAJJ4nCZh__nASYX-Uk_jBjV&_nc_ohc=7QIvHzgb2ckQ7kNvwGdCj-4&_nc_oc=AdnNZxY1BMgvGsHa5uB2hjIrj7LzfS-Z33O1duyJIyh73V5fz83Pc6de40HUz_HO2GY&_nc_zt=23&_nc_ht=scontent.ftcq2-1.fna&_nc_gid=dKGSfR-bV-xwAADaRpJyew&oh=00_AfIkDTGjg0m7kKVYZscBrEZC8p53Du0vBOJJBRp6XfkISQ&oe=684F1281"
					alt="informacion acerca de que es la eutrofizacion"
					data-sal="slide-right"
					data-sal-duration="1000"
				/>
				<img
					className="rounded-lg"
					src="https://pbs.twimg.com/media/DqbVbxpWwAAe9a4?format=jpg&name=small"
					alt="comparacion entre natural y eutrofizacion"
					data-sal="slide-left"
					data-sal-duration="1000"
				/>
			</Column>
		</>
	);
};
